<template>
	<div>
		<div class="context">
			<div class="page-zyjnds" ws='wer'>
				<h2 class="text-center" contenteditable="true" placeholder="标题"></h2>
				<h3 class="text-center" contenteditable="true" placeholder="副标题"></h3>
				<div draggable="true" :key="index" :id="index" v-for="(item,index) in modules" @dragover.prevent
					@dragstart="drag($event,index)" @drop="drop($event,index)" @dblclick="del(index)">
					<component :is="item.name"></component>
				</div>
			</div>
		</div>
		<div style="text-align: center;">
			<el-button @click="dialogVisible = true">添加组件</el-button>
			<el-button @click="initHTML">生成HTML</el-button>
		</div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="70%">
			<el-button @click="addModule('chapter')">chapter</el-button>
			<el-button @click="addModule('text-field')">text-field</el-button>
			<el-button @click="addModule('node')">node</el-button>
			<el-button @click="addModule('WSImage')">WSImage</el-button>
			<el-button @click="addModule('WSImageBig')">WSImage</el-button>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>

</template>

<script>
	import Chapter from './components/chapter.vue'
	import TextField from './components/text-field.vue'
	import Node from './components/node.vue'
	import Image from './components/Image.vue'
	import ImageBig from './components/ImageBig.vue'
	export default {
		components: {
			Chapter,
			TextField,
			Node,
			WSImage: Image,
			WSImageBig: ImageBig
		},
		data() {
			return {
				dialogVisible: false,
				modules: []
			}
		},
		methods: {
			addModule(module) {
				this.modules.push({
					name: module,
					data: {}
				})
				this.dialogVisible = false
			},
			del(index) {
				this.$confirm('是否删除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.modules.splice(index, 1)
				}).catch(() => {});
			},
			drag(e, index) {
				e.dataTransfer.setData("index", index);
			},
			drop(e, index) {
				let a = e.dataTransfer.getData('index')
				let b = index
				let data = this.modules[a]
				this.$set(this.modules, a, this.modules[b])
				this.$set(this.modules, b, data)
			},
			initHTML() {
				const style = `
				<style>
					.page-zyjnds {
						max-width: 980px;
						min-width: 670px;
						padding: 20px;
						margin: auto;
						font-size: 16px;
						position: relative;
						background: #fff;
						padding: 40px;
					}
				
					.page-zyjnds img {
						border: 1px solid #ccc;
						display: block;
						margin: 20px auto;
						width: 600px;
					}
				
					.page-zyjnds img.big {
						width: 100%;
						margin: 20px 0;
					}
				
					.page-zyjnds .small {
						display: flex;
						margin: 50px auto;
						justify-content: center;
						flex-wrap: wrap;
					}
				
					.page-zyjnds .small img {
						width: 400px;
						margin: 20px 10px;
					}
				
					.text-center {
						text-align: center;
					}
				
				
					.text-field {
						background-color: rgb(248, 248, 248);
						line-height: 30px;
						text-indent: 2em;
						padding: 20px;
						letter-spacing: 1px
					}
				
					.padding-top-0 {
						padding-top: 0;
					}
				
					.padding-bottom-0 {
						padding-bottom: 0;
					}
				
					.chapter {
						position: relative;
						font-size: 22px;
						font-weight: 700;
						margin: 60px 0 20px;
					}
				
					.chapter .num {
						position: absolute;
						top: 15px;
						background-color: #fff;
						width: 50px;
						height: 50px;
						border: 2px solid rgb(195, 163, 142);
						display: flex;
						align-items: center;
						justify-content: center;
					}
				
					.chapter .title {
						background-color: rgb(228, 212, 197);
						height: 80px;
						display: flex;
						align-items: center;
						width: calc(100% - 30px);
						margin-left: 30px;
					}
				
					.chapter .title span {
						border-bottom: 5px solid rgb(195, 163, 142);
						margin-left: 50px;
						padding-bottom: 5px;
					}
				
					.node {
						font-size: 20px;
						padding: 20px;
						font-weight: 700;
					}
				
					.node .icon {
						padding-right: 16px;
						color: rgb(255, 205, 25);
					}
				</style>
				`
				let doc = document.querySelector('.context')
				this.$confirm('是否生成HTML，将不可修改', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					doc.querySelectorAll('*').forEach(item => {
						item.removeAttribute('contenteditable')
					})
					document.execCommand(style + doc.innerHTML)
					this.$alert(style + doc.innerHTML, 'HTML', {
						confirmButtonText: '确定',
						customClass: 'html-context',
						callback: action => {}
					});
				}).catch(() => {});
			}
		}

	}
</script>

<style>
	.html-context {
		width: 80%;
	}

	.page-zyjnds {
		max-width: 980px;
		min-width: 670px;
		padding: 20px;
		margin: auto;
		font-size: 16px;
		position: relative;
		background: #fff;
		padding: 40px;
	}

	.page-zyjnds .text-center:empty:before {
		content: attr(placeholder);
		color: #aaa;
	}

	.page-zyjnds img {
		border: 1px solid #ccc;
		display: block;
		margin: 20px auto;
		width: 600px;
	}

	.page-zyjnds img.big {
		width: 100%;
		margin: 20px 0;
	}

	.page-zyjnds .small {
		display: flex;
		margin: 50px auto;
		justify-content: center;
		flex-wrap: wrap;
	}

	.page-zyjnds .small img {
		width: 400px;
		margin: 20px 10px;
	}

	.text-center {
		text-align: center;
	}


	.text-field {
		background-color: rgb(248, 248, 248);
		line-height: 30px;
		text-indent: 2em;
		padding: 20px;
		letter-spacing: 1px
	}

	.padding-top-0 {
		padding-top: 0;
	}

	.padding-bottom-0 {
		padding-bottom: 0;
	}

	.chapter {
		position: relative;
		font-size: 22px;
		font-weight: 700;
		margin: 60px 0 20px;
	}

	.chapter .num {
		position: absolute;
		top: 15px;
		background-color: #fff;
		width: 50px;
		height: 50px;
		border: 2px solid rgb(195, 163, 142);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.chapter .title {
		background-color: rgb(228, 212, 197);
		height: 80px;
		display: flex;
		align-items: center;
		width: calc(100% - 30px);
		margin-left: 30px;
	}

	.chapter .title span {
		border-bottom: 5px solid rgb(195, 163, 142);
		margin-left: 50px;
		padding-bottom: 5px;
	}

	.node {
		font-size: 20px;
		padding: 20px;
		font-weight: 700;
	}

	.node .icon {
		padding-right: 16px;
		color: rgb(255, 205, 25);
	}
</style>
